import Bugsnag from "@bugsnag/js"

import { getBugsnagConfig } from "./config"

/**
 * Idempotent Bugsnag starter. Returns true when the notifier is live (either
 * already started or just started by this call), false when no API key is
 * configured.
 *
 * Used by:
 *   - instrumentation.ts          (Node runtime boot)
 *   - instrumentation-client.ts   (browser boot)
 *   - onRequestError              (safety net if a runtime boot was skipped)
 *
 * Centralising the start call means every entry point ships the same config —
 * release stage, redaction list, per-customer metadata — without drift.
 */
export function startBugsnag(): boolean {
  if (Bugsnag.isStarted()) return true
  const config = getBugsnagConfig()
  if (!config) return false
  Bugsnag.start(config)
  return true
}
